<template>
  <div class="social-account-callback-view d-flex fill-height">
    <Spinner class="ma-auto"/>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { RouteLocationRaw } from 'vue-router';
import API from '@/api/wrapper';
import Spinner from '@/components/UIElements/Spinner.vue';
import { ToastrDescriptor } from '@/types';
import { APISocialAccount } from '@/typesAPI';

@Options({
  components: {
    Spinner,
  },
})
export default class SocialAccountCallbackView extends Vue {

  mounted(): void {
    const socialProvider = this.$route.params.socialProvider.toString()
    const code = this.$route.query.code

    if (typeof code !== 'string') {
      this.$router.replace(this.returnRoute)
      return
    }

    API.social.callback(this.$store.getters['user/getUser'].id, socialProvider, code, this.redirectUrl)
    .then((socialAccount:APISocialAccount) => {
      this.$store.dispatch('user/setSocialAccount', {provider: socialProvider, socialAccount: socialAccount})
    })
    .catch((err:any) => {
      if (!err?.toastr?.id) {
        const descriptor:ToastrDescriptor = {
          title: '',
          text: 'Your account could not be connected. Please try again.',
          severity: this.$enums.Severity.DANGER,
          id: `social-account-callback-${socialProvider}`,
        }
        this.$store.dispatch('toastrs/addDescriptor', descriptor)
      }
    })
    .finally(() => {
      this.$router.replace(this.returnRoute)
    })
  }

  // The URL the provider sent the person back to, which it requires again to exchange the code.
  get redirectUrl():string {
    const urlParams = new URLSearchParams(window.location.search)
    urlParams.delete('code')

    return `${window.location.origin}${window.location.pathname}?${urlParams.toString()}`
  }

  // GitHub comes back without any state when the app's settings are saved from github.com.
  get returnRoute():RouteLocationRaw {
    const origin:{[key:string]: string} = {}
    new URLSearchParams(window.location.search).get('state')?.split('|').forEach((part:string) => {
      const [key, value] = part.split('=')
      origin[key] = value
    })
    const {projectId, blockId, tabId, boxId} = origin

    if (projectId && blockId && tabId && boxId) {
      return {name: 'flowBlockAndBox', params: {projectId, blockId, tabId, boxId}}
    }
    if (projectId && blockId && tabId) {
      return {name: 'flowBlock', params: {projectId, blockId, tabId}}
    }
    if (projectId) {
      return {name: 'flow', params: {projectId}}
    }

    return {name: 'home'}
  }
}
</script>
